/**
 * Submit component
 * 
 */

import React, { PureComponent } from 'react';

export default class Submit extends PureComponent {
	
	static displayName = 'submit';

	render() {

		const { children: label } = this.props;
		
		return (

			<div className="form-button">
				<button type="submit" className="btn btn-primary">{label}</button>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/forms/fields/submit.js